<div class="container">
  <div class="content">
    <h3 class="title">404</h3>
    <div class="border-bottom" />

    <h3>Page Not Found</h3>

    <h3><a href="/" style="text-decoration:none;padding:0.5rem 1rem;border-radius:10px;background-color:rgb(150,150,150);">Home</a></h3>
  </div>
</div>
<style>
    .content {
  width: 600px;
  padding: 2rem;
  text-align: center;
  /* background-color: #333333; */
  background-color: rgb(53, 53, 49);
  border-radius: 10px;
  overflow-x: hidden;
  margin: 0 auto; /* Center the content */
    }
    a {
      border: 1px solid #AAAAAA;
    }
</style>
